module.exports = __webpack_public_path__ + "ENG_SPT4-Trees_225002956-32d48e0566e5bcf2b9e940134a07dabf.png";